<template>
  <div class="wrap_address">
    <div class="contacts">
      <h4 class="title-color">Contact Information</h4>
    </div>
    <div class="e-card-separator"></div>
    <div class="form-row">
      <div style="width: 650px" class="form-row-input">
        <ejs-textbox
          float-label-type="Always"
          placeholder="User Name"
          v-model="username"
          :readonly="true"
        />
      </div>
    </div>
    <div class="contacts">
      <div class="contact-card" v-for="(contact, index) in contactDetails" :key="index">
        <div class="form-row">
          <div style="width: 650px" class="form-row-input">
            <ejs-dropdownlist
              float-label-type="Always"
              id="phoneType"
              ref="phoneType"
              :dataSource="phoneTypeData"
              v-model="contact.phoneType"
              :change="onPhoneTypeChange(contact.phoneType, index)"
              placeholder="Phone Type"
            />
          </div>
        </div>
        <div style="display: flex">
          <div class="form-row">
            <div
              class="form-row-input"
              style="width: 650px"
              v-show="!contact.isFax"
            >
              <scc-input-validator
                :rules="[requiredRule]"
                :value="contact.phoneNumber"
                @validate="(v) => (contact.isPhoneNumberValid = v)"
              >
                <ejs-textbox
                  ref="phone"
                  float-label-type="Always"
                  placeholder="Phone"
                  :value="contact.phoneNumber"
                  :maxlength="12"
                  @input="formatPhoneNumber($event.value, contact)"
                />
              </scc-input-validator>
            </div>

            <div
              style="width: 650px"
              class="form-row-input"
              v-show="contact.isFax"
            >
              <ejs-textbox
                name="default"
                float-label-type="Always"
                placeholder="Fax"
                v-model="contact.phoneNumber"
              >
              </ejs-textbox>
            </div>
            <div
              style="width: 325px"
              class="form-row-input"
              v-show="!contact.isFax && contact.isWork"
            >
              <ejs-numerictextbox
                name="phone"
                format="###"
                :showSpinButton="false"
                float-label-type="Always"
                placeholder="Phone Ext"
                v-model="contact.ext"
              >
              </ejs-numerictextbox>
            </div>
          </div>
        </div>
        <div class="form-row" v-if="isUserLogged">
          <div style="float: left">
            <ejs-radiobutton
              label="Default"
              v-show="!contact.isFax"
              name="default"
              :checked="contact.isDefault === true"
              :value="contact.isDefault"
              v-on:change="defaultPhone(index)"
            ></ejs-radiobutton>
          </div>
        </div>
        <div class="row-action-buttons">
            <font-awesome-icon
              :icon="['fas', 'trash-alt']"
              style="color: red; font-size: 26px; padding-right: 5px"
              @click="remove(index)"
              v-show="(!contact.isDefault)"
            />
          </div>
      </div>
      <div class="common-action-buttons">
 <font-awesome-icon
              :icon="['fas', 'plus-circle']"
              style="color: green; font-size: 26px"
              @click="add()"
            />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

import { DropDownListPlugin } from '@syncfusion/ej2-vue-dropdowns';
import {
  TextBoxPlugin,
  NumericTextBoxPlugin,
  MaskedTextBoxPlugin,
} from '@syncfusion/ej2-vue-inputs';
import { ButtonPlugin, RadioButtonPlugin } from '@syncfusion/ej2-vue-buttons';
import SccInputValidator from '../../../components/base/scc-input-validator.vue';

import { USER_PHONES, GET_USER_CONTACTS, UPDATE_USER_CONTACTS } from '../store';

Vue.use(DropDownListPlugin);
Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(MaskedTextBoxPlugin);
Vue.use(ButtonPlugin);
Vue.use(RadioButtonPlugin);

export default {
  name: 'ContactInfo',
  components: {
    SccInputValidator,
  },
  props: {
    userProfileId: String,
    userProfilesData: Object,
  },
  created() {},
  mounted() {
    if (this.$store.getters.loggedUser !== null) this.getUserContacts();
  },
  computed: {
    username: {
      get() {
        return this.userProfilesData ? this.userProfilesData.userName : '';
      },
      set(val) {
        return val;
      },
    },
    // username() {
    //   return this.userProfilesData ? this.userProfilesData.userName : '';
    // },
    isUserLogged() {
      return this.$store.getters.loggedUser;
    },
  },
  data() {
    return {
      phoneTypeData: ['Home', 'Cell', 'Work', 'Fax'],
      isUpdateContact: false,
      contactDetails: [
        {
          id: null,
          phoneType: null,
          phoneNumber: null,
          ext: '',
          userId: null,
          isDefault: false,
          deleteFlag: false,
          isPhoneNumberValid: false,
          isFax: false,
          isWork: false,
        },
      ],
      requiredRule: {
        regEx: '^(?!\\s*$).+',
        message: 'This field is required',
      },
      numericRule: {
        regEx: '^\\d+$',
        message: 'This field is required numeric value',
      },
      phoneNumberRule: {
        regEx: '^.{1,10}$',
        message: 'Phone number shold have 10 digits.',
      },
    };
  },
  methods: {
    notify(type, message) {
      this.$parent.$parent.$parent.notificationToasts.push({
        title: type,
        content: message,
        cssClass: type === 'Error' ? 'e-toast-danger' : 'e-toast-success',
        timeOut: 5000,
      });
      if (this.$parent.$parent.$parent.notificationToasts.length > 0) {
        this.$parent.$parent.$parent.$refs.notifierRef.show();
      }
    },
    add() {
      const userId = this.userProfileId; // this.$store.getters.loggedUser.id;
      this.contactDetails.push({
        phoneType: null,
        phoneNumber: null,
        ext: '',
        userId,
        isDefault: false,
        isPhoneNumberValid: false,
        isFax: false,
        isWork: false,
      });
    },
    formatPhoneNumber(input, contact) {
      input = input.replace(/\D/g, '');
      const size = input.length;
      if (size > 3) { input = `${input.slice(0, 3)}-${input.slice(3, 11)}`; }
      if (size > 6) { input = `${input.slice(0, 7)}-${input.slice(7)}`; }
      contact.phoneNumber = input;
    },
    remove(index) {
      if (this.contactDetails[index].id !== null) this.contactDetails[index].deleteFlag = true;
      this.contactDetails.splice(index, 1);
    },
    onPhoneTypeChange(phoneType, index) {
      if (phoneType === 'Fax') {
        this.contactDetails[index].isFax = true;
      } else this.contactDetails[index].isFax = false;
      if (phoneType === 'Work') {
        this.contactDetails[index].isWork = true;
      } else this.contactDetails[index].isWork = false;
    },
    defaultPhone(index) {
      this.contactDetails.forEach((contact, contactIndex) => {
        const data = contact;
        if (contactIndex === index) data.isDefault = true;
        else data.isDefault = false;
      });
    },
    phoneNumberFocus(args) {
      const arg = args;
      arg.selectionEnd = 0;
      arg.selectionStart = 0;
    },
    validateContact() {
      for (let i = 0; i < this.contactDetails.length; i += 1) {
        this.contactDetails[i].phoneNumber = this.contactDetails[i].phoneNumber === null
          ? ''
          : this.contactDetails[i].phoneNumber;
      }
      return this.contactDetails && this.contactDetails.length > 0
        ? !this.contactDetails.some((x) => x.phoneNumber == null || x.phoneNumber === '') : true;
    },
    async getUserContacts() {
      try {
        const userId = this.userProfileId; // this.$store.getters.loggedUser.id;
        await this.$store.dispatch(GET_USER_CONTACTS, { userId });
        const contacts = this.$store.getters.userContactsbyUserID;
        this.contactDetails = [];
        for (let j = 0; j < contacts.length; j += 1) {
          this.contactDetails.push({
            id: contacts[j].id,
            phoneType: contacts[j].phoneType,
            phoneNumber: contacts[j].phoneNumber,
            ext: contacts[j].ext,
            userId,
            isDefault: contacts[j].isDefault,
            deleteFlag: false,
            isPhoneNumberValid: false,
            isFax: contacts[j].phoneType === 'Fax',
            isWork: contacts[j].phoneType === 'Work',
          });
        }
        // this.contactDetails = this.$store.getters.userContactsbyUserID;

        if (this.contactDetails.length === 0) {
          this.contactDetails.push({
            phoneType: null,
            phoneNumber: null,
            ext: '',
            userId,
            isDefault: true,
            deleteFlag: false,
            isPhoneNumberValid: false,
            isFax: false,
            isWork: false,
          });
        } else if (this.contactDetails.length > 0) this.isUpdateContact = true;
      } catch (err) {
        console.error(err);
      }
    },
    async updateUserContacts(hideNofificationMessage) {
      // this.$parent.$parent.$parent.notificationToasts.length = 0;
      try {
        // const userId = this.$store.getters.loggedUser.id;
        const data = this.contactDetails;
        await this.$store.dispatch(UPDATE_USER_CONTACTS, { data });
        if (!hideNofificationMessage) {
          this.notify('Success!', 'Updated contact information.');
        }
      } catch (err) {
        this.notify('Error', 'Opss! Something went wrong.');
      }
    },
    async userContactInfo() {
      try {
        // this.phoneType = this.$refs.phoneType.ej2Instances.value;
        // console.log('contactDetails:', this.contactDetails);
        this.contactDetails[0].userId = this.userProfileId;
        // this.$store.getters.confirmedUser.userId;
        this.contactDetails[0].isDefault = true;
        const {
          id, phoneType, phoneNumber, ext, userId, isDefault,
        } = this.contactDetails[0];
        await this.$store.dispatch(USER_PHONES, {
          id,
          phoneType,
          phoneNumber,
          ext,
          userId,
          isDefault,
        });
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>
<style>
.Treeview1:before {
  content: "\e22c";
}
.Treeview2:before {
  content: "\e22b";
}
.contact-card {
    padding: 20px;
    background: #f9f9f9;
    margin-bottom: 20px;
    width:100%;
    margin-top: 10px;
    border-radius: 3px;
    border-bottom: none;
}
.row-action-buttons {
    text-align: right;
    padding: 10px;
}
.contacts {
  max-width: 700px;
}
.common-action-buttons {
    padding: 5px;
    text-align: right;
}
.common-action-buttons> svg , .row-action-buttons > svg {
cursor: pointer;
}
.btn-save-contact-info-container {
    max-width: 700px;
}

</style>
